import { render, staticRenderFns } from "./orders_and_invoices.page.vue?vue&type=template&id=c22591d0&scoped=true&"
import script from "./orders_and_invoices.page.vue?vue&type=script&lang=js&"
export * from "./orders_and_invoices.page.vue?vue&type=script&lang=js&"
import style0 from "./orders_and_invoices.page.vue?vue&type=style&index=0&id=c22591d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22591d0",
  null
  
)

export default component.exports